import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzUploadFile } from 'ng-zorro-antd/upload';
import { Observable, Observer } from 'rxjs';

@Component({
  selector: 'app-learning-center-profile-image-uploader',
  templateUrl: './learning-center-profile-image-uploader.component.html',
  styleUrls: ['./learning-center-profile-image-uploader.component.scss']
})
export class LearningCenterProfileImageUploaderComponent implements OnInit {

  @Input() learningCenterForm: FormGroup;
  @Input() isEdit: boolean = false;
  
  loading: boolean = false;
  imageUrl?: string
  fileList: NzUploadFile[] = [];

  constructor(private messageService: NzMessageService) { }

  ngOnInit(): void {
    if (this.isEdit) {
      this.imageUrl = this.learningCenterForm.get('IMAGE_PROFILE')?.value;
    }
  }

  get imageProfile (): FormControl {
    return this.learningCenterForm.get('IMAGE_PROFILE') as FormControl;
  }

  beforeUpload = (file: NzUploadFile, _fileList: NzUploadFile[]) => {
    return new Observable((observer: Observer<boolean>) => {
      const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
      if (!isJpgOrPng) {
        this.messageService.error('รองรับเฉพาะไฟล์ .jpg และ .png เท่านั้น', { nzDuration: 5000 });
        observer.next(false);
        observer.complete();
        return;
      }
      const isLt5M = file.size! / 1024 / 1024 < 5;
      if (!isLt5M) {
        this.messageService.error('รองรับไฟล์ขนาดไม่เกิน 5 mb', { nzDuration: 5000 });
        observer.next(false);
        observer.complete();
        return;
      }
      // Create a new Image object to load the file into it and check its dimensions
      const reader = new FileReader();
      reader.onloadend = () => {
        const img = new Image();
        img.onload = () => {
          const isWidthHeightValid = img.width === 434 && img.height === 324;
          if (!isWidthHeightValid) {
            this.messageService.warning('แนะนำให้ใช้รูปภาพขนาด 434x324 พิกเซล', { nzDuration: 5000 });
          }
          observer.next(isJpgOrPng && isLt5M);
          observer.complete();
        };
        img.onerror = () => {
          this.messageService.error('ไม่สามารถโหลดรูปภาพได้', { nzDuration: 5000 });
          observer.next(false);
          observer.complete();
        };
        // Set the img.src to the data URL
        img.src = reader.result as string;
      };
      // Read the file as a Data URL
      reader.readAsDataURL(file.originFileObj || file as any);
    });
  };
  private getBase64(img: File, callback: (img: string) => void): void {
    const reader = new FileReader();
    reader.addEventListener('load', () => callback(reader.result!.toString()));
    reader.readAsDataURL(img);
  }

  handleChange(info: { file: NzUploadFile }): void {
    switch (info.file.status) {
      case 'uploading':

        break;
      case 'done':
        // Get this url from response in real world.
        this.getBase64(info.file!.originFileObj!, (img: string) => {
          this.loading = false;
          this.imageUrl = img;
        });
        this.fileList = []
        this.learningCenterForm.get('IMAGE_PROFILE')?.setValue(info.file.originFileObj);
        break;
      case 'error':

        this.loading = false;
        break;
    }
  }

  successRequest = ({ file, onSuccess, onError }) => {
    setTimeout(() => {
      onSuccess('ok');
    }, 0);
  };

}
